import { motion } from "framer-motion";
import { string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import { useTranslation } from "@lib/i18n";

import LoadingDots from "./LoadingDots";

const HorizontalLoader = ({ className }) => {
  const { t } = useTranslation();

  return (
    <motion.p
      animate="animated"
      className={twMerge(
        "inline-block capitalize text-inherit text-[length:inherit]",
        className
      )}
      variants={{
        start: { opacity: 0 },
        animated: {
          opacity: 1,
          transition: { staggerChildren: 0.5, delayChildren: 0.3 },
        },
      }}
      initial="start"
    >
      {t("loading")} <LoadingDots />
    </motion.p>
  );
};

HorizontalLoader.propTypes = {
  className: string,
};

export default HorizontalLoader;
